import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { UPLOAD_BASE_PATH } from "../../config/upload";
import {
  UserCircleIcon,
  EnvelopeIcon,
  PhoneIcon,
  BuildingOfficeIcon,
  KeyIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import { User, UserFormData } from "./user";
import { useAppDispatch, useAppSelector } from "../../store";
import {
  updateUser,
  selectUserLoading,
  setSelectedUser,
  createUser,
} from "./userSlice";
import {
  selectBranches,
  selectBranchLoading,
} from "../branch/branchSlice";
import BaseModal from "../../components/common/BaseModal";
import FormInput from "../../components/common/FormInput";
import { STUB_BRANCHES } from "../../config/stubData";
import { stageService, Stage } from "../../feature/stageModule";
import { UserStage } from "./user";
import {
  Box,
  Typography,
  Paper,
  Divider,
} from "@mui/material";
import StagesDropdown from "../../form/StagesDropdown";
import TextInputField from "../../form/TextInputField";
import EmailField from "../../form/EmailField";
import PhoneField from "../../form/PhoneField";
import DropdownField from "../../form/DropdownField";
import PasswordField from "../../form/PasswordField";
import { ReusableSidebar } from "@/components/public";
import { enhancedApiClient, isSuccessResponse, ApiResponse } from "../../services/enhancedApiClient";
import { config } from "../../config/environment"
import { masterDropdownService } from "../../services/masterDropdownService";

interface EditUserModalProps {
  isOpen: boolean;
  onRequestClose: (hasData: boolean) => void;
  onSuccess?: () => void;
  mode: "create" | "edit";
  user: User | null;
  // onFormDirty?: (dirty: boolean) => void
}

const userTypeOptions = [
  { value: "regular", label: "Regular User" },
  { value: "supervisor", label: "Supervisor" },
  { value: "operator", label: "Operator" },
  { value: "quality_control", label: "Quality Control" },
];



const EditUserModal: React.FC<EditUserModalProps> = ({
  isOpen,
  onRequestClose,
  onSuccess,
  mode,
  user,
  // onFormDirty,...props
  
}) => {
  const dispatch = useAppDispatch();
  const branches = useAppSelector(selectBranches);
  const branchesLoading = useAppSelector(selectBranchLoading);
  const userLoading = useAppSelector(selectUserLoading);
  const selectedUser = useAppSelector(
    (state) => state.users.selectedUser
  );
  
  const [formData, setFormData] = useState<Partial<UserFormData>>({
    username:"",
    email: "",
    firstName: "",
    // lastName: "",
    role: "worker" ,
    userType: "regular",
    status: true,
    phone: "",
    branchId:"",
    skills: [],
    photo: "",
    avatarUrl: "",
    profilePic: undefined,
  });

  



  const [initialFormData, setInitialFormData] = useState<Partial<UserFormData>>({});
  const [initialSelectedStages, setInitialSelectedStages] = useState<string[]>([]);

  const [errors, setErrors] = useState<Record<string, string>>({});
  const [profilePreview, setProfilePreview] = useState<string | null>(null);
  const [image, setImage] = useState(null)
  const [imageUrl, setImageUrl] = useState('');
  const fileInputRef = useRef<HTMLInputElement>(null);
  // Updated interface to handle both old and new stage structures
  interface StageOption {
    id: string;
    stageId?: string; // For new structure
    name: string;
    code?: string; // For new structure
    category?: string; // For old structure
  }

  const isFormDirty = (): boolean => {
    return !!(
      formData.branchId.trim() ||
      formData.email.trim() ||
      formData.firstName.trim() ||
      formData.phone.trim() ||
      // formData.skills.length >= 0 ||
      formData.username.trim() 
    );
  };
  
  const [selectedStages, setSelectedStages] = useState<string[]>([]);
  // Initialize with fallback options to prevent MUI Select error when formData.role is set before API loads
  const [roleOptions, setRoleOptions] = useState<Array<{ value: string; label: string }>>([
    { value: "admin", label: "Admin" },
    { value: "branch_admin", label: "Branch Admin" },
    { value: "sales_person", label: "Sales Person" },
    { value: "supervisor", label: "Supervisor" },
    { value: "operator", label: "Operator" },
    { value: "manager", label: "Manager" },
  ]);

  // Fetch role types from API
  useEffect(() => {
    const fetchRoleTypes = async () => {
      try {
        const options = await masterDropdownService.getRoleTypesDropdown();
        // Options already have role_name as value and display_name as label from backend
        // No transformation needed - backend provides display_name directly
        // Filter out super_admin from the options
        const filteredOptions = options
          .filter(option => 
            option.value !== 'super_admin' && option.value !== 'superadmin'
          )
          .map(option => ({
            value: String(option.value), // Ensure value is string
            label: String(option.label)   // Ensure label is string
          }));
        console.log('Role options loaded:', filteredOptions);
        setRoleOptions(filteredOptions);
      } catch (error) {
        console.error('Failed to fetch role types:', error);
        // Fallback to default options if API fails (excluding super_admin)
        const fallbackOptions = [
          { value: "admin", label: "Admin" },
          { value: "branch_admin", label: "Branch Admin" },
          { value: "sales_person", label: "Sales Person" },
          { value: "supervisor", label: "Supervisor" },
          { value: "worker", label: "Operator" },
          { value: "manager", label: "Manager" },
        ];
        console.log('Using fallback role options:', fallbackOptions);
        setRoleOptions(fallbackOptions);
      }
    };
    
    if (isOpen) {
      fetchRoleTypes();
    }
  }, [isOpen]);

  useEffect(() => {
    console.log("profilePreview: ",profilePreview)
    console.log('User-----', user);
    console.log('t', console.log('User-----', user))
  },[profilePreview,user])

  useEffect(() => {
    if (isOpen) {
      console.log('EditUserModal - User data:', user);
      console.log('EditUserModal - User userStages:', user?.userStages);
      console.log('EditUserModal - User stages:', user?.stages);

      // Keep the role as-is from database (could be 'worker' or 'operator')
      // If user has 'worker' in database but we're using 'operator' in dropdown, normalize for display
      // If user has 'operator' in database, keep it as 'operator'
      const userRole = user?.role === 'worker' ? 'operator' : (user?.role || "operator");
      
      const newFormData = {
        username: user?.username || "",
        email: user?.email || "",
        firstName: user?.firstName || "",
        role: userRole,
        userType: user?.userType || "regular",
        status: typeof user?.status === 'boolean' ? user.status : user?.status === 'active',
        phone: user?.phone || "",
        branchId: user?.branchId || "",
        skills: user?.skills || [],
        photo: user?.photo,
        avatarUrl: user?.avatarUrl,
        profilePic: undefined,
      };

      setFormData(newFormData);
      setInitialFormData(newFormData);

      // Stages logic - handle both old and new stage structures
      let stageIds: string[] = [];
      if (user?.userStages && user.userStages.length > 0) {
        // Handle new structure with stageId
        stageIds = user.userStages.map(stage => stage.stageId || stage.id);
        console.log('Setting selectedStages from userStages:', stageIds);
      } else  {
        console.log('No stages found, setting empty array');
        stageIds = [];
      }
      setSelectedStages(stageIds);
      setInitialSelectedStages(stageIds);

      // Set profile preview if user has avatar
      setProfilePreview(user?.avatarUrl ? `${removeLastEndpoint(config.API_URL)}${UPLOAD_BASE_PATH}/${user.avatarUrl}` : null);
    }
  }, [isOpen, user, selectedUser, dispatch]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    const newValue = type === "checkbox" ? (e.target as HTMLInputElement).checked : value;
    
    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: newValue,
      };
      
      // If role is changed to admin, clear the branch assignment
      // Admins are common for all branches and should not have branch-specific assignment
      if (name === "role" && value === "admin") {
        updated.branchId = "";
        console.log('Role changed to admin - clearing branch assignment');
      }
      
      // If role is changed from worker to any other role, clear stage assignments
      // Stages are only applicable to worker role (Operator uses 'worker' as the dropdown value)
      if (name === "role" && prev.role === "operator" && value !== "operator") {
        setSelectedStages([]);
        console.log('Role changed from worker to ' + value + ' - clearing stage assignments');
      }
      
      return updated;
    });
    
    // Clear error when field is edited
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  

  const handleStagesChange = (event: any) => {
    const value = event.target.value;
    console.log('handleStagesChange - new value:', value);
    setSelectedStages(typeof value === 'string' ? value.split(',') : value);

    // Clear stages error when stages are selected
    if (errors.stages) {
      setErrors((prev) => ({ ...prev, stages: "" }));
    }
  };

  function removeLastEndpoint(url) {
    // Remove trailing slash if present, then remove everything after the last "/"
    return url.replace(/\/+$/, "").substring(0, url.replace(/\/+$/, "").lastIndexOf("/"));
  }

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Clear the input immediately to prevent multiple triggers
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    try {
      const formData = new FormData();
      formData.append("photo", file, file.name);
      
      if (mode === 'create') {
        formData.append("forNewUser", "true");
      } else {
        // When editing, send the userId so the photo is linked to the correct user
        formData.append("forNewUser", "false");
        if (user?.id) {
          formData.append("userId", user.id);
        }
      }

      const response = await enhancedApiClient.post("/upload/user", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data && response.data.filename) {
        setImageUrl(response.data.filename);
        console.log("UPLOAD_BASE_PATH: ",UPLOAD_BASE_PATH)
        console.log("config: ",config)
        console.log("enhancedapiclient: ",enhancedApiClient)
        console.log("response.data.filename: ",response.data.filename)
        setProfilePreview(`${removeLastEndpoint(config.API_URL)}${UPLOAD_BASE_PATH}/${response.data.filename}`);
        setFormData((prev) => ({ ...prev, profilePic: response.data.filename }));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      // Preview is already set from FileReader above, so we keep it
    }
  };

  const validateForm = (): boolean => {
    const newErrors: Record<string, string> = {};

    if (!formData.firstName) newErrors.firstName = "First name is required";
    // if (!formData.lastName) newErrors.lastName = "Last name is required";
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.role) newErrors.role = "Role is required";
    // if (!formData.userType) newErrors.userType = "User type is required";
    // Branch selection is optional for all roles; no validation error
    
    // Password validation for create mode
    if (mode === "create" && (!formData.password || formData.password.trim() === "")) {
      newErrors.password = "Password is required";
    } else if (mode === "create" && formData.password && formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    
    // Stages validation for worker role (Operator uses 'worker' as the dropdown value)
    if (formData.role === "operator" && (!selectedStages || selectedStages.length === 0)) {
      newErrors.stages = "Stages are required for operator role";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        // Send role as-is (use 'operator' instead of normalizing to 'worker')
        const submissionData: UserFormData = {
          username: formData.username || "",
          email: formData.email || "",
          firstName: formData.firstName || "",
          // lastName: formData.lastName || "",
          role: formData.role || "operator",
          userType: formData.userType || "regular",
          status: formData.status ?? true,
          phone: formData.phone || "",
          avatarUrl: formData.avatarUrl || "",
          // branchId: formData.branchId || "",
          branchId :
            formData.role === "admin"
              ? ""
              : (branches.length > 0 ? branches[0].id : ""),
          skills: formData.skills || [],
          photo: imageUrl || "",
          stages: selectedStages, // Send stages field as expected by backend
          password: mode === "create" ? (formData.password || "") : "", // Use actual password for create, empty for updates
          profilePic: formData.profilePic,
        };
        console.log("submissionData: ",submissionData);
      
        if (mode === "edit" && user) {
          
          console.log("=============> user", user);
          await dispatch(
            updateUser({ id: user.id, userData: submissionData })
          ).unwrap();
        } else {
          await dispatch(createUser(submissionData)).unwrap();
        }
        dispatch(setSelectedUser(null));
        console.log("User operation successful, calling onSuccess");
        if (onSuccess) {
          onSuccess();
        }
        return; // Close via parent state change, don't trigger onClose
      } catch (error: any) {
        console.error("User operation failed:", error);
        // Extract specific error message from the error
        const errorMessage = error?.message || error?.toString() || 
          (mode === "edit" ? "Failed to update user. Please try again." : "Failed to create user. Please try again.");
        
        setErrors((prev) => ({
          ...prev,
          submit: errorMessage,
        }));
        // Don't close the modal or clear the form on error
        return;
      }
    }
  };

  return (
    // <BaseModal isOpen={isOpen} onClose={onClose} title={mode === "edit" ? "Edit User" : "Create User"}>
    <div
      className={`fixed inset-0 z-50 transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={() => onRequestClose(isFormDirty())}
      ></div>

      {/* Slide-in Panel */}
      <div
        className={`absolute right-0 top-0 h-full w-[30%] bg-white shadow-xl transform transition-transform duration-1000 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full"> 
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">
              {mode === "edit" ? "Edit User" : "Create User"}
            </h2>
            <button
              onClick={() => onRequestClose(isFormDirty())}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
            >
              ✕
            </button>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-6">  
            <form onSubmit={handleSubmit} noValidate className="space-y-4">
                <div className="flex flex-col items-center space-y-2">
                  <label
                    htmlFor="profilePic"
                    className="text-sm font-medium text-gray-700"
                  >
                    Profile Picture
                  </label>

                  {/* <img
                        src={ profilePreview}
                        alt="Profile Pic"
                        className="w-full h-full object-cover"
                      /> */}

                  {/* Circular Profile Picture */}
                  <div
                    className="relative w-24 h-24 rounded-full border-2 border-gray-300 cursor-pointer overflow-hidden bg-gray-100 flex items-center justify-center hover:border-gray-400 transition-colors"
                    onClick={() => {
                      if (fileInputRef.current) {
                        fileInputRef.current.click();
                      }
                    }}
                  >
                    {/* Hidden file input */}
                    <input
                      ref={fileInputRef}
                      id="profilePic"
                      type="file"
                      accept="image/*"
                      name="profilePic"
                      onChange={handleImageChange}
                      className="absolute inset-0 opacity-0 cursor-pointer"
                      onClick={(e) => {
                        // Prevent multiple clicks from triggering multiple dialogs
                        e.stopPropagation();
                      }}
                    />

                    {profilePreview ? (
                      <img
                        src={profilePreview}
                        alt="Profile Pic"
                         style={{
                          width: "200px",
                          height: "200px",
                          objectFit: "cover",
                          borderRadius: "10px",
                          border: "1px solid #ccc",
                        }}
                      />
                    ) : (
                      <UserIcon className="w-12 h-12 text-gray-400" />
                    )}
                  </div>
                  <p className="text-xs text-gray-500">Click to upload image</p>
                </div>
              
                <TextInputField
                  label="Full Name"
                  name="firstName"
                  value={formData.firstName || ""}
                  onChange={handleChange}
                  required
                  icon={<UserIcon className="h-5 w-5 text-gray-500" />}
                />
                {/* <TextInputField
                  label="Last Name"
                  name="lastName"
                  value={formData.lastName || ""}
                  onChange={handleChange}
                  required
                  icon={<UserIcon className="h-5 w-5 text-gray-500" />}
                /> */}
                {/* <TextInputField
                  label="Username"
                  name="username"
                  value={formData.username || ""}
                  onChange={handleChange}
                  required
                  icon={<UserIcon className="h-5 w-5 text-gray-500" />}
                /> */}

                {mode === "create" &&(
                  <PasswordField
                    label="Password"
                    name="password"
                    value={formData.password || ""}
                    onChange={handleChange}
                    required
                    showError={!!errors.password}
                    helperText={errors.password || "Password must be at least 6 characters"}
                  />
                )}

                <EmailField
                  label="Email"
                  name="email"
                  value={formData.email || ""}
                  onChange={handleChange}
                  required
                />

                <PhoneField
                  label="Phone"
                  name="phone"
                  value={formData.phone || ""}
                  onChange={handleChange}
                />

                {/* <FormInput
                  icon={<PhoneIcon className="h-5 w-5" />}
                  label="Phone"
                  name="phone"
                  type="tel"
                  value={formData.phone || ""}
                  onChange={handleChange}
                  placeholder="Enter phone number"
                  error={errors.phone}
                /> */}
              {/* </div> */}

              
                <DropdownField
                  label="Role"
                  name="role"
                  value={formData.role && roleOptions.some(opt => opt.value === formData.role) ? formData.role : ""}
                  required
                  icon={<KeyIcon className="h-5 w-5 text-gray-500" />}
                  options={roleOptions}
                  placeholder="Select Role"
                  onChange={(e) => {
                    const role = e.target.value;
                    console.log('Role dropdown changed - selected value:', role, 'roleOptions:', roleOptions);
                    setFormData((prev) => ({
                      ...prev,
                      role: role as typeof prev.role,
                    }));
                  }}
                />

                {/* <DropdownField
                  icon={<BuildingOfficeIcon className="h-5 w-5" />}
                  label="Branch"
                  name="branchId"
                  value={formData.branchId || ""}
                  onChange={handleChange}
                  required={!["admin"].includes(formData.role || "")}
                  disabled={
                    branchesLoading ||
                    ["admin"].includes(formData.role || "") ||
                    branches.length === 0
                  }
                  showError={!!errors.branchId}
                  helperText={errors.branchId}
                  placeholder={
                    ["admin"].includes(formData.role || "")
                      ? "No branch required for this role"
                      : branchesLoading
                      ? "Loading branches..."
                      : branches.length === 0
                      ? "No branches available"
                      : "Select branch (optional)"
                  }
                  options={
                    branches.length === 0
                      ? [{ value: "", label: "No branches available" }]
                      : branches.map((branch: any) => ({
                          value: branch.id,
                          label: branch.name,
                        }))
                  }
                /> */}
           

              {/* Stages Selection - Only show for worker role (Operator uses 'worker' as the dropdown value) */}
              {formData.role === "operator" && (
                <div>
                  <StagesDropdown
                    label="Stages"
                    name="stages"
                    value={selectedStages}
                    required
                    onChange={handleStagesChange}
                    error={errors.stages}
                  />
                </div>
              )}

              {errors.submit && (
                <p className="text-sm text-red-500 dark:text-red-400 bw:text-black mt-2">
                  {errors.submit}
                </p>
              )}

              <div className="flex justify-end space-x-3 mt-6">
                <button
                  type="button"
                  onClick={() => onRequestClose(isFormDirty())}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                  disabled={userLoading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-indigo-500 dark:hover:bg-indigo-400 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-60"
                  disabled={userLoading}
                >
                  {userLoading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      {mode === "edit" ? "Updating..." : "Creating..."}
                    </>
                  ) : (
                    mode === "edit" ? "Update User" : "Create User"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    // </BaseModal>
  );
};

export default EditUserModal;
